module.exports = "<div class=\"secureClientMsgBg\">\r\n    <div class=\"secureClientMsgBox\">\r\n        <img class=\"secureClientMsgImg\" src=\"/public/images/secureClientMsg_img.png\"/>\r\n        <div class=\"secureClientMsgTitleBox\">\r\n            <div class=\"secureClientMsgTitle\">登录超时或无法识别安全客户端，请重新启动安全客户端再尝试登录!</div>\r\n            <div class=\"secureClientMsgTitle1\"> Please restart the secure client and try to login again!</div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n\r\n\r\n\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/component/secureClient/index.html
// module id = 205
// module chunks = 0